// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Divider = require("../../common/Components/Divider.bs.js");
let Spinner = require("../../../uikit/reason/atoms/Spinner/Spinner.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
let Theme__Color = require("../../../reason/common/Theme/Theme__Color.bs.js");
let RadioButtonNew = require("../../../uikit/reason/atoms/Form/RadioButtonNew.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let VisuallyHidden = require("@reach/visually-hidden").default;
let ClientNeedsPageRelayQueryParams = require("./ClientNeedsPageRelayQueryParams.bs.js");
let ClientNeedsPageRelayActiveFiltersList = require("./ClientNeedsPageRelayActiveFiltersList.bs.js");
let ClientNeedsPageRelayFiltersMobileMenu = require("./ClientNeedsPageRelayFiltersMobileMenu.bs.js");
let ClientNeedsPageRelayFiltersDesktopMenu = require("./ClientNeedsPageRelayFiltersDesktopMenu.bs.js");

function ClientNeedsPageRelayControls(props) {
  let setSelectedAreas = props.setSelectedAreas;
  let refetch = props.refetch;
  let isRefetching = props.isRefetching;
  let totalCount = props.totalCount;
  let selectedAreas = props.selectedAreas;
  let match = ClientNeedsPageRelayQueryParams.use();
  let params = match[0];
  let isDesktop = MediaQuery.isDesktop();
  let match$1 = React.useState(() => false);
  let setMobileMenuIsOpen = match$1[1];
  return JsxRuntime.jsxs("div", {
    children: [
      isDesktop ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs(RadioButtonNew.RadioButtonGroup.make, {
                children: [
                  JsxRuntime.jsx(RadioButtonNew.make, {
                    label: "Buying",
                    name: "search-type",
                    id: "search-type-buying",
                    onChange: param => refetch(undefined, undefined, undefined, p => {
                      let newrecord = {...ClientNeedsPageRelayQueryParams.preserveRelevantParamsWhenSwitchingModes(p)};
                      newrecord.rentalMode = false;
                      return newrecord;
                    }),
                    checked: !params.rentalMode
                  }),
                  JsxRuntime.jsx(RadioButtonNew.make, {
                    label: "Renting",
                    name: "search-type",
                    id: "search-type-renting",
                    onChange: param => refetch(undefined, undefined, undefined, p => {
                      let newrecord = {...ClientNeedsPageRelayQueryParams.preserveRelevantParamsWhenSwitchingModes(p)};
                      newrecord.rentalMode = true;
                      return newrecord;
                    }),
                    checked: params.rentalMode
                  })
                ]
              }),
              className: ""
            }),
            JsxRuntime.jsx(ClientNeedsPageRelayFiltersDesktopMenu.make, {
              selectedAreas: selectedAreas,
              setSelectedAreas: setSelectedAreas,
              refetch: refetch
            }),
            JsxRuntime.jsx("div", {
              children: isRefetching ? JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Spinner.make, {
                      size: 16,
                      stroke: Theme__Color.toString(Theme__Color.jumbo)
                    }),
                    JsxRuntime.jsx(VisuallyHidden, {
                      children: "Loading"
                    })
                  ],
                  className: "h-7.5 pl-4 pb-0.5 flex items-center font-medium text-gray-600"
                }) : totalCount.toString() + ` results`,
              className: "p-2 pl-4 border-l"
            })
          ],
          className: "flex flex-row gap-4 items-center flex-wrap"
        }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => setMobileMenuIsOpen(param => true),
              size: "small",
              icon: "filters",
              children: "Edit Filters"
            }),
            JsxRuntime.jsx(ClientNeedsPageRelayFiltersMobileMenu.make, {
              isOpen: match$1[0],
              onClose: () => setMobileMenuIsOpen(param => false),
              refetch: refetch,
              selectedAreas: selectedAreas,
              setSelectedAreas: setSelectedAreas,
              isRefetching: isRefetching,
              totalCount: totalCount
            })
          ]
        }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Divider.make, {}),
        className: "my-4"
      }),
      JsxRuntime.jsx(ClientNeedsPageRelayActiveFiltersList.make, {
        params: params,
        selectedAreas: selectedAreas,
        refetch: refetch
      })
    ],
    className: "p-6 bg-white rounded-md"
  });
}

let QueryParams;

let DesktopMenu;

let ActiveFiltersList;

let RadioButtonGroup;

let RadioButton;

let make = ClientNeedsPageRelayControls;

exports.QueryParams = QueryParams;
exports.DesktopMenu = DesktopMenu;
exports.ActiveFiltersList = ActiveFiltersList;
exports.RadioButtonGroup = RadioButtonGroup;
exports.RadioButton = RadioButton;
exports.make = make;
/* react Not a pure module */
